import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LoginComponent = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isValidIP, setIsValidIP] = useState(true);

  useEffect(() => {
    checkIPAccess();

    const adminVerified = localStorage.getItem('adminVerified');
    if (adminVerified === 'true') {
      onLoginSuccess();
    }
  }, []);

  const checkIPAccess = async () => {
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      const currentIP = response.data.ip;
      const allowedIPs = ['27.100.25.18', '117.221.66.34'];

      if (allowedIPs.includes(currentIP)) {
        setIsValidIP(true);
      } else {
        setError('Access Denied: Unauthorized IP Address');
        setIsValidIP(false);
        // Clear any existing storage if IP is not allowed
        localStorage.removeItem('adminVerified');
        localStorage.removeItem('adminToken');
      }
    } catch (err) {
      setError('Failed to verify IP address');
      setIsValidIP(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!email || !password) {
      setError('Please enter both email and password');
      setLoading(false);
      return;
    }

    try {
      const payload = {
        apikey: process.env.REACT_APP_API_KEY,
        module: "admin",
        method: "verifyAdmin",
        emailaddress: email,
        password: password
      };

      const response = await axios.post(process.env.REACT_APP_API_URL, payload);
      const jsonData = JSON.parse(response.data.body);
      console.log('jsonData1', jsonData)
      if (jsonData.status === "success") {
        localStorage.setItem('adminVerified', 'true');
        console.log('jsonData', jsonData)
        // if (jsonData.token) {
        //   localStorage.setItem('adminToken', jsonData.token);
        // }   
        onLoginSuccess();
    
      } else {
        setError('Invalid credentials. Please try again.');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          
          
                /* Login Page CSS */
                * {
                  box-sizing: border-box;
                  margin: 0;
                  padding: 0;
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                }

                body {
                  background-color: #f5f5f5;
                }

                .login-container {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  min-height: 100vh;
                  padding: 20px;
                  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
                }

                .login-form-container {
                  width: 100%;
                  max-width: 450px;
                  background-color: white;
                  border-radius: 10px;
                  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
                  padding: 40px;
                  position: relative;
                  overflow: hidden;
                }

                .login-title {
                  font-size: 28px;
                  font-weight: 700;
                  color: #333;
                  margin-bottom: 8px;
                  text-align: center;
                }

                .login-subtitle {
                  font-size: 14px;
                  color: #666;
                  margin-bottom: 30px;
                  text-align: center;
                }

                .login-form {
                  display: flex;
                  flex-direction: column;
                  gap: 20px;
                }

                .form-group {
                  display: flex;
                  flex-direction: column;
                  gap: 8px;
                }

                .form-group label {
                  font-size: 14px;
                  font-weight: 600;
                  color: #444;
                }

                .input-container {
                  position: relative;
                  display: flex;
                  align-items: center;
                }

                .input-icon {
                  position: absolute;
                  left: 12px;
                  font-size: 16px;
                }

                .input-container input {
                  width: 100%;
                  padding: 12px 40px 12px 40px;
                  border: 1px solid #ddd;
                  border-radius: 6px;
                  font-size: 14px;
                  transition: all 0.3s ease;
                }

                .input-container input:focus {
                  outline: none;
                  border-color: #4c84ff;
                  box-shadow: 0 0 0 3px rgba(76, 132, 255, 0.2);
                }

                .input-container input::placeholder {
                  color: #aaa;
                }

                .visibility-toggle {
                  position: absolute;
                  right: 12px;
                  background: none;
                  border: none;
                  cursor: pointer;
                  font-size: 16px;
                }

                .form-options {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 5px;
                  margin-bottom: 5px;
                }

                .remember-me {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                }

                .remember-checkbox {
                  width: 16px;
                  height: 16px;
                  accent-color: #4c84ff;
                }

                .forgot-password {
                  color: #4c84ff;
                  font-size: 14px;
                  text-decoration: none;
                  transition: color 0.2s;
                }

                .forgot-password:hover {
                  color: #2c64ff;
                  text-decoration: underline;
                }

                .login-button {
                  background-color: #4c84ff;
                  color: white;
                  border: none;
                  border-radius: 6px;
                  padding: 12px;
                  font-size: 16px;
                  font-weight: 600;
                  cursor: pointer;
                  transition: background-color 0.3s;
                }

                .login-button:hover {
                  background-color: #3a74ff;
                }

                .login-button:disabled {
                  background-color: #a5bdff;
                  cursor: not-allowed;
                }

                .error-message {
                  background-color: #fff2f2;
                  border-left: 4px solid #ff4d4d;
                  padding: 12px;
                  margin-bottom: 20px;
                  color: #e60000;
                  border-radius: 4px;
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                }

                .error-icon {
                  margin-right: 10px;
                }

                .copyright {
                  text-align: center;
                  margin-top: 30px;
                  font-size: 12px;
                  color: #888;
                }

                /* Add some animation effects */
                @keyframes fadeIn {
                  from { opacity: 0; transform: translateY(20px); }
                  to { opacity: 1; transform: translateY(0); }
                }

                .login-form-container {
                  animation: fadeIn 0.5s ease-out;
                }

                /* Responsive adjustments */
                @media (max-width: 480px) {
                  .login-form-container {
                    padding: 30px 20px;
                  }
                  
                  .login-title {
                    font-size: 24px;
                  }
                  
                  .form-options {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 10px;
                  }
                }
        `}
      </style>
      <div className="login-container">
        <div className="login-form-container">
          <h1 className="login-title">Admin Login</h1>
          <p className="login-subtitle">Enter your credentials to access the dashboard</p>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <div className="input-container">
                <span className="input-icon email-icon">✉️</span>
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-container">
                <span className="input-icon password-icon">🔒</span>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="visibility-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </button>
              </div>
            </div>

            {/* <div className="form-options">
              <div className="remember-me">
                <input
                  id="remember"
                  type="checkbox"
                  className="remember-checkbox"
                />
                <label htmlFor="remember">Remember me</label>
              </div>
              <a href="#" className="forgot-password">Forgot your password?</a>
            </div> */}

            <button
              type="submit"
              disabled={loading || !isValidIP}
              className="login-button"
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          <div className="copyright">
            © {new Date().getFullYear()} Admin Dashboard. All rights reserved.
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginComponent;